import './version';
export * from '@fluentui/react-window-provider';
//# sourceMappingURL=WindowProvider.js.map